import { ApiAccount } from '../openapi';

export function isAccountMatch(query: string, account: ApiAccount) {
  // Search by account ID
  if (account.id === query) return true;

  // Search by holder ID
  if (account.holderId === query) return true;

  // Search by account name
  if (account.name?.toLowerCase().includes(query)) return true;

  // Search by currency
  if (account.balance.currency?.toLowerCase().includes(query)) return true;

  return false;
}
